import { transEnum } from '@luminovo/commons';
import { solutionStatusTranslations } from '../i18n';
import { SolutionStatus } from '../types';

export function formatSolutionStatus(status: SolutionStatus): string {
    return transEnum(status, solutionStatusTranslations);
}
